import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { deleteCommentEducations, getCommentEducations } from '../../utilities/sendRequest';
import { dateTimeIndo } from '../../utilities/helper';

const CardComments = ({ educationId, fetchAgain, setFetchAgain }) => {
    const [fetchMore, setFetchMore] = useState(false)
    const [datas, setDatas] = useState([])

    useEffect(() => {
        if(educationId) {
            fetchComments();
            setFetchMore(false);
            setFetchAgain(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchMore, fetchAgain, educationId])

    const fetchComments = async () => {
        getCommentEducations(educationId).then((res) => {
            setDatas(
                res.payload.sort((p1, p2) => {
                    return new Date(p2.createdAt) - new Date(p1.createdAt)
                })
            )
        }).catch((err) => {
            toast.error(err, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        })  
    }

    const columns = [
        {
            field: 'user_fullname',
            headerName: 'Employee',
            width: 250,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.user_fullname}
                    </div>
                )
            } 
        },
        {
            field: 'user_nip',
            headerName: 'NIP',
            width: 100,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.user_nip}
                    </div>
                )
            } 
        },
        {
            field: 'office',
            headerName: 'Office',
            width: 250,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.office}
                    </div>
                )
            } 
        },
        {
            field: 'comment',
            headerName: 'Comment',
            width: 300,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.comment}
                    </div>
                )
            } 
        },
        {
            field: 'createdAt',
            headerName: 'Time',
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {dateTimeIndo(params.row.createdAt)}
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 250,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row gap-3 items-center'>
                        <div onClick={() => handleAction(params.row.id)} className='px-3 py-2 rounded-md bg-red-500 text-white tracking-wider cursor-pointer'>
                            Delete
                        </div>
                    </div>
                )
            }
        },
    ]

    const handleAction = (paramsId) => {
        deleteCommentEducations(paramsId).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
        }).catch((error) => {
            toast.error(error.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        })
    }

    return (
        <div className={`my-5 flex flex-col lg:flex-row justify-start gap-7 md:gap-10`}>
            {/* list data */}
            <div className='w-full h-full flex flex-col gap-3 items-center'>
                <h1 className='font-semibold text-xl self-start'>Comment List</h1>
                <div className="p-2 w-full flex flex-col bg-white drop-shadow-lg rounded-md">
                    <DataGrid
                        autoHeight {...datas}
                        rows={datas}
                        columns={columns}
                        pageSize={5}
                        getRowId={(row) => row.id}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar, }}
                    />
                </div>
            </div>
        </div>
    )
}

CardComments.propTypes = {
    educationId: PropTypes.number,
    fetchAgain: PropTypes.bool,
    setFetchAgain: PropTypes.func,
}

export default CardComments